import styled from "styled-components";
import { LOGO_HOME } from "@assets";

export const Bar = styled.div`
  height: 70px;
  padding-inline: 16px;
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  background: ${(props) => props.theme.appbarColor};
  z-index: 1000;
`;

export const LogoWrapper = styled.div``;

export const Logo = styled(LOGO_HOME)``;

export const IconsWrapper = styled.div`
  gap: 8px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  svg {
    cursor: pointer;
  }

  @media screen and (max-width: 320px) {
    gap: 6px;

    svg {
      width: 20px;
    }
  }
`;

export const MessageWrapper = styled.div`
  background: rgba(0, 54, 117, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFF;
  padding: 5px 8px;
  border-radius: 50px;
  gap: 4px;
`;

export const Text = styled.div`
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 100;
  line-height: 1.5;

  @media screen and (max-width: 320px) {
    font-size: 13px;
  }
`;
